'use strict';

function initPostalCodeInputs() {
    $(document).on('input', '[data-postal-code-input]', function () {
        this.value = this.value
            .replace(/\D/g, '')
            .slice(0, 4);
    });
}

module.exports = initPostalCodeInputs;